module.exports = __webpack_public_path__ + "assets/img/weight_close.7d2e1bfd.svg";